import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/newsletters.action';
import * as utility from '../../../utility';

export interface NewslettersState {
  result?: any;
  loaded: boolean;
  loading: boolean;
  showWindow: boolean;
  initShowWindow: boolean;
  error?: any;
}

export const initialState: NewslettersState = {
  loaded: false,
  loading: false,
  showWindow: true,
  initShowWindow: false,
};

export const NewslettersReducer = createReducer(
  initialState,
  on(pageActions.Subscribe, (state: NewslettersState) => {
    return {
      ...state,
      loaded: false,
      loading: true,
      error: undefined,
    };
  }),
  on(pageActions.SubscribeSuccess, (state: NewslettersState, { result }) => {
    return {
      ...state,
      result,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.SubscribeFail, (state: NewslettersState, { error }) => {
    return {
      ...state,
      result: undefined,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.ShowNewsletterPopup, (state: NewslettersState) => {
    return {
      ...state,
      showWindow: true,
    };
  }),
  on(pageActions.HideNewsletterPopup, (state: NewslettersState) => {
    return {
      ...state,
      showWindow: false,
    };
  }),
  on(pageActions.InitNewsletterPopup, (state: NewslettersState) => {
    return {
      ...state,
      initShowWindow: true,
    };
  })
);

export const getNewsletterSubscriptionResult = (state: NewslettersState) => state.result;
export const getNewsletterSubscriptionError = (state: NewslettersState) => state.error;
export const getNewsletterSubscribing = (state: NewslettersState) => state.loading;
export const getNewsletterSubscribed = (state: NewslettersState) => state.loaded;
export const getNewsletterShowWindow = (state: NewslettersState) => state.showWindow;
export const getInitNewsletterPopup = (state: NewslettersState) => state.initShowWindow;
